module.exports = __webpack_public_path__ + "img/cases-brand-hla-15.3d5894f1.png";